module.exports = __webpack_public_path__ + "static/media/box_options.861e8cde.png";